<div class="row columns fullscreentext" *ngIf="showComponent()">
	<div class="content" [innerHtml]="getText()"></div>
	<iframe *ngIf="step == 'dataprotection'" style='border: 0; height: 200px; width: 100%' [src]="'https://statistic.twingle.de/index.php?module=CoreAdminHome&action=optOut&language=' + language | safeUrl "></iframe>
</div>